import { render, staticRenderFns } from "./KeberatanKinerja.vue?vue&type=template&id=0dfdb755&scoped=true&"
import script from "./KeberatanKinerja.vue?vue&type=script&lang=js&"
export * from "./KeberatanKinerja.vue?vue&type=script&lang=js&"
import style0 from "./KeberatanKinerja.vue?vue&type=style&index=0&id=0dfdb755&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfdb755",
  null
  
)

export default component.exports